"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersistedState = void 0;
var react_1 = require("react");
function usePersistedState(key, initialState) {
    var _a = (0, react_1.useState)(function () {
        var storageValue = localStorage.getItem(key);
        if (storageValue) {
            return JSON.parse(storageValue);
        }
        return initialState;
    }), state = _a[0], setState = _a[1];
    (0, react_1.useEffect)(function () {
        state !== undefined && localStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);
    return [state, setState];
}
exports.usePersistedState = usePersistedState;
